import request from '../../../shared/request'

export function getJobList() {
  return request('/jobs')
}

export function updateJobDetail(payload) {
  return request(`/jobs/${payload.job_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}
export function createJob(payload) {
  return request(`/jobs/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJob(payload) {
  return request(`/jobs/${payload.job_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function inactivateJob(payload) {
  return request(`/jobs/${payload.job_id}/inactivate`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function activateJob(payload) {
  return request(`/jobs/${payload.job_id}/activate`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getJobDetails(job_id) {
  return request(`/jobs/${job_id}/details/`)
}

export function getChildrenJobs(job_id) {
  return request(`/jobs/${job_id}/children/`)
}

export function getAttachments(payload) {
  return request(`/attachments/${payload.job_id}/${payload.type}/`)
}

export function getEstimateTemplates() {
  return request(`/templates/estimate`)
}

export function getTemplateSecions(template_id) {
  return request(`/templates/estimate/${template_id}/section`)
}

export function getTemplateItems(template_id) {
  return request(`/templates/estimate/${template_id}/item`)
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobs.js